import {useEffect, useState} from "react";
import {
    useDeleteMyOrderMutation,
    useMyOrdersQuery,
    useOrdersHistoryQuery
} from "../services/react-query/useOrdersQuery";



const useCurrentOrders = () => {
    const {mutate: deleteOrder} = useDeleteMyOrderMutation()


    const [deleteModal, setDeleteModal] = useState({id: null, open: false})
    const onCloseDeleteModal = () => {
        deleteModal.open && setDeleteModal({ id: null, open: false })
    }
    const onModalClicked = (submit) => {
        if (submit) {
            deleteOrder(deleteModal.id)
        }
        setDeleteModal({id: null, open: false})
    }

    return {
        deleteModal,
        setDeleteModal,
        onCloseDeleteModal,
        onModalClicked
    }
}


export {
    useCurrentOrders
}
